import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { hexToRgb } from './util'

const Path = styled.section`
  position: absolute;
  z-index: 9990;
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
  bottom: 1rem;
  left: 1rem;
  padding: 1rem;
  background: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`

const PathSection = styled.div`
  position: relative;
  display: flex;
  margin: 0.25rem 0;
  padding: 0;
`

const Dot = styled.section`
  position: relative;
  width: 1rem;
  height: 1rem;
  background: ${p => p.color};
  border-radius: 50%;
  margin: 0 0.5rem;
  box-shadow: 0 0 0 4px transparent;
  transition: box-shadow 150ms;

  :hover {
    box-shadow: 0 0 0 4px rgba(${p => hexToRgb(p.color)}, 0.24);
  }

  ::after {
    content: '';
    position: absolute;
    top: 50%;
    margin-top: -0.0625rem;
    left: 1rem;
    width: 1rem;
    height: 0.125rem;
    background: ${p => p.color};
  }

  :last-child {
    ::after {
      display: none;
    }
  }
`

export default class PathNavigator extends PureComponent {
  render() {
    const { coordinates, legend, flyTo } = this.props
    return (
      <Path>
        {Object.keys(coordinates)
          .sort()
          .map(path => (
            <PathSection key={path}>
              <b>Book {path.replace('twf-', '')}</b>
              {coordinates[path].map((dot, i) => {
                const [{ color }] = legend.filter(l => l.id === path)
                return (
                  <Dot key={dot} color={color} onClick={() => flyTo(dot)} />
                )
              })}
            </PathSection>
          ))}
      </Path>
    )
  }

  static propTypes = {}
}



// WEBPACK FOOTER //
// ./src/PathNavigator.js